import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// TERM LOAN AGENCY VERIFICATION
// Legacy: /AccountsApproval/VerifyTermLoanAgency (+ VerifyTermLoanAgencyGrid / VerifyTermLoanAgencyView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — agencies pending at this role's level.
export const getVerificationTLAgencies = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetApprovalTLAgency`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of one agency by agency code (carries MOID, address, group).
export const getTLAgencyByCode = async (agencyCode) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetApproveTLAgencyCodebyid`, { params: { id: agencyCode }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Return / Reject (spApproveTLAgency — success literal "Submitted").
export const approveTLAgency = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/ApproveTLAgency`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Resubmit a returned agency (spInsertUpdateAgency with CheckUpdationType 'ReturnUpdate' — "Submitted").
export const updateReturnedTLAgency = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/EditTermLoanAgency`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
